export default __webpack_public_path__ + "static/media/mobile.bc01befa.jpg";